import { Component, OnDestroy, OnInit } from '@angular/core';
import { SubSink } from 'subsink';
import { Router } from '@angular/router';

import { TrendingCategoriesService } from '../../services/trending-category/trending-categories.service';
import { AppImagesService } from '../../../core/services/app-images/app-images.service';

import { categorySwiperConfig } from '../../../../models';
import { ScreenCategory } from '../../../shared';

@Component({
  selector: 'signgaze-trending-categories-container',
  templateUrl: './trending-categories-container.component.html',
  styleUrls: ['./trending-categories-container.component.scss'],
})
export class TrendingCategoriesContainerComponent implements OnInit, OnDestroy {
  readonly subSink: SubSink = new SubSink();
  readonly categoryconfig = categorySwiperConfig;
  dummySource =
    'https://image.freepik.com/free-vector/vector-cartoon-illustration-banner-urban-background-with-modern-big-city-buildings_1441-586.jpg';
  categoryImageMap: Map<ScreenCategory, string>;
  trendingScreenCategories: string[];

  constructor(
    private trendingCategoriesService: TrendingCategoriesService,
    private appImagesService: AppImagesService,
    private router: Router
  ) {
    this.categoryImageMap = this.appImagesService.getCategoryImagesMap();
  }

  ngOnInit(): void {
    this.subSink.sink = this.trendingCategoriesService
      .getTrendingCategories()
      .subscribe({
        next: (trendingScreenCategories: any): void => {
          this.trendingScreenCategories = trendingScreenCategories;
        },
      });
  }

  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }

  public navigateToSearchPage(screenCategory: string): void {
    const encodedScreenCategory: string = encodeURI(screenCategory);
    this.router.navigate(['/listings'], {
      queryParams: { screenCategories: encodedScreenCategory },
    });
  }
}
